import { render, staticRenderFns } from "./Course.vue?vue&type=template&id=8d9e545a&scoped=true"
import script from "./Course.vue?vue&type=script&lang=js"
export * from "./Course.vue?vue&type=script&lang=js"
import style0 from "./Course.vue?vue&type=style&index=0&id=8d9e545a&prod&lang=scss&scoped=true"
import style1 from "./Course.vue?vue&type=style&index=1&id=8d9e545a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d9e545a",
  null
  
)

export default component.exports